import classNames from "classnames";
import { Icon, Typography } from "components";
import styles from "./FilterChip.module.css";

interface FilterChipProps {
  label: string;
  color?: string;
  overlay?: string;
  image?: string;
  active?: boolean;
  disabled?: boolean;
  onClick(): void;
}

const FilterChip: React.FC<FilterChipProps> = ({
  image,
  label,
  active,
  color = "#eee",
  overlay = "black",
  onClick,
  disabled,
}) => {
  const className = classNames(
    styles.container,
    active && styles.active,
    disabled && styles.disabled
  );

  const style = {
    background: color,
    "--overlay": overlay,
  } as React.CSSProperties;

  return (
    <button className={className} style={style} onClick={onClick}>
      <span className={styles.overlay} />
      {active && (
        <Icon
          name="check"
          color="white"
          container={{
            size: "24px",
            color: "rgba(0, 0, 0, 0.5)",
            style: { position: "absolute", left: "7px" },
          }}
        />
      )}
      {image && (
        <img
          src={image}
          alt={label}
          height={18}
          width={18}
          style={{ objectFit: "contain", overflow: "hidden" }}
        />
      )}
      <Typography size={-1}>{label}</Typography>
    </button>
  );
};

export { FilterChip };
